import { css } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import InlineFlex from 'reakit/InlineFlex';
import 'reakit/Grid';
var sizeAttributes = {
  default: css(["&{", ";}"], theme('fannypack.Badge.sizes.default')),
  medium: css(["&{font-size:1rem;", ";}"], theme('fannypack.Badge.sizes.medium')),
  large: css(["&{font-size:1.25rem;", ";}"], theme('fannypack.Badge.sizes.large'))
};

var _Badge = styled(InlineFlex).withConfig({
  displayName: "styled",
  componentId: "lb6y7a-0"
})(["align-items:center;border-radius:1rem;justify-content:center;background-color:", ";box-sizing:content-box;padding:0 0.4em;color:", ";fill:", ";font-size:", "rem;font-weight:", ";height:1.2em;", " ", " ", " &{", ";}"], palette(), function (props) {
  return palette(props.palette + "Inverted");
}, function (props) {
  return palette(props.palette + "Inverted");
}, theme('fannypack.fontSizes.100'), theme('fannypack.fontWeights.semibold'), function (props) {
  return !props.children && css(["&{height:0.5rem;width:0.5rem;padding:0px;}"]);
}, function (props) {
  return props.isAbsolute && css(["position:absolute;top:-0.4em;right:-0.4em;&{", ";}"], theme('fannypack.Badge.absolute'));
}, function (props) {
  return props.styledSize && sizeAttributes[props.styledSize];
}, theme('fannypack.Badge.base'));

export default _Badge;